import { DEADLINE_BUCKETS, type DeadlineBucket, isExistingIsoDay } from '@prospero/shared';

import { DEADLINE_DEEP_LINK_PARAM } from './use-deadline-deep-link';

export const DEADLINE_STATUS_PARAM = 'deadlineStatus';
export const DEADLINE_FROM_PARAM = 'deadlineFrom';
export const DEADLINE_TO_PARAM = 'deadlineTo';

/** Filtro "Scadenze" di /documents: stato e/o periodo, `''` = non impostato. */
export interface DeadlineUrlFilter {
  status: DeadlineBucket | '';
  from: string;
  to: string;
}

export const EMPTY_DEADLINE_FILTER: DeadlineUrlFilter = { status: '', from: '', to: '' };

function isDeadlineBucket(raw: string | null): raw is DeadlineBucket {
  return raw !== null && (DEADLINE_BUCKETS as readonly string[]).includes(raw);
}

/** Solo giorni che esistono: `2026-13-45` non deve scivolare su un'altra data. */
function toExistingDay(raw: string | null): string {
  return isExistingIsoDay(raw) ? raw : '';
}

export function parseDeadlineFilter(searchParams: URLSearchParams): DeadlineUrlFilter {
  const rawStatus = searchParams.get(DEADLINE_STATUS_PARAM);
  return {
    status: isDeadlineBucket(rawStatus) ? rawStatus : '',
    from: toExistingDay(searchParams.get(DEADLINE_FROM_PARAM)),
    to: toExistingDay(searchParams.get(DEADLINE_TO_PARAM)),
  };
}

export function serializeDeadlineFilter(params: URLSearchParams, filter: DeadlineUrlFilter): void {
  if (filter.status) {
    params.set(DEADLINE_STATUS_PARAM, filter.status);
  }
  if (filter.from) {
    params.set(DEADLINE_FROM_PARAM, filter.from);
  }
  if (filter.to) {
    params.set(DEADLINE_TO_PARAM, filter.to);
  }
}

/**
 * Link a una singola scadenza: la sezione filtrata sul suo giorno (o sulle senza data) con la riga
 * indicata da `deadlineId`, così la riga è sempre tra quelle mostrate.
 */
export function buildSingleDeadlineQuery(deadlineId: string, dueAt: string | null): string {
  const params = new URLSearchParams();
  if (dueAt) {
    serializeDeadlineFilter(params, { status: '', from: dueAt, to: dueAt });
  } else {
    serializeDeadlineFilter(params, { status: 'NO_DEADLINE', from: '', to: '' });
  }
  params.set(DEADLINE_DEEP_LINK_PARAM, deadlineId);
  return params.toString();
}

export function hasDeadlineFilter(filter: DeadlineUrlFilter): boolean {
  return Boolean(filter.status || filter.from || filter.to);
}
